import React from "react";
import Card from "components/card";

const HeaderComponent = (props) => {
  const {
    icon,
    title,
    description,
    titleClass = "text-[16px] title-text",
    descriptionClass = "text-[12px] muted-text",
    header,
    children,
    rightNav,
    bgcolor,
    colorTheme,
    labelIcon,
    footer,
    border,
    cardBorder = "border dark:border-gray-700",
    backgroundStyle,
  } = props;

  return (
    <Card className={`rounded-2xl text-slate-900 shadow-sm h-full flex flex-col ${cardBorder} bg-white dark:bg-black/5 overflow-x-scroll xl:overflow-x-hidden`}>
      {header ? (
        header
      ) : (
        <div
          className={`relative grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 p-6 ${border} ${bgcolor}`}
        >
          {backgroundStyle && backgroundStyle}

          <div className="flex items-center justify-between w-full relative">
            <div className="flex items-center gap-3">
              {icon && (
                <div className={`p-2 flex items-center justify-center bg-text ${colorTheme}`}>
                  {icon}
                </div>
              )}
              <div className="min-w-0">
                <div className="flex items-center gap-1.5">
                  <div className="inline-flex gap-1.5 flex items-center">
                    {labelIcon && <div className="text-green-600">{labelIcon}</div>}
                    <h4 className={`dark:text-white ${titleClass}`}>{title}</h4>
                  </div>
                </div>
                {description && <p className={descriptionClass}>{description}</p>}
              </div>
              <div className="absolute top-1 right-5">{rightNav}</div>
            </div>
          </div>
        </div>
      )}

      {children && <div className="px-5 pb-2 bg-transparent">{children}</div>}

      {footer && <div>{footer}</div>}
    </Card>
  );
};

export default HeaderComponent;
